/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Advanced/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Advanced({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/SendCommunication/EmailTemplateEditor/Content/Editor/Advanced",
  onChange
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let eventActionDataEmailTemplateContentValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.email_template.content',
})
let eventActionDataEmailTemplateContentChangeData = fromData.useDataChange({ viewPath,
context: 'event_action',
path: 'data.email_template.content',
})
let constantData = 'email-template-'
let eventActionIdValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'id',
})
let aggregateData = fromAggregate.joinNoSpace(constantData, eventActionIdValueData)
let tokensValueData = fromData.useDataValue({ viewPath,
context: 'tokens',
})
  return (<React.Fragment
>
<div
  data-testid="Advanced.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-ZLf9ed': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Advanced.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 data="event_action.data.email_template.content"
 value={eventActionDataEmailTemplateContentValueData}
 onChange={eventActionDataEmailTemplateContentChangeData}
 data="'email-template-'"
 data="event_action.id"
 aggregate="/Data/aggregate.js joinNoSpace"
 containerId={aggregateData}
 marginTop={0}
 marginBottom={0}
 parentHeight={200}
 width="100%"
 toolbarPersist={true}
 toolbar="advanced"
 data="tokens"
 tokens={tokensValueData}
/>
</div>
</div>
{children}
</React.Fragment>)
}